import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAcTQQhrvIVn0sMfmc8xfg90Nqd5ArdbL4",
  authDomain: "techyid-6c663.firebaseapp.com",
  projectId: "techyid-6c663",
  storageBucket: "techyid-6c663.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "761279201712",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:761279201712:web:e7bcc6b7c9043b3db39675"
};

// Initialize Firebase
let app;
try {
  // Check if Firebase is already initialized
  if (getApps().length === 0) {
    app = initializeApp(firebaseConfig);
    console.log('✅ Firebase initialized successfully!');
    console.log('��� Project ID:', firebaseConfig.projectId);
    console.log('��� Using production Firebase services');
  } else {
    app = getApp();
    console.log('✅ Using existing Firebase app');
  }
} catch (error) {
  console.error('❌ Firebase initialization failed:', error);
  // Create a fallback app with minimal config
  app = initializeApp(firebaseConfig, 'fallback');
}

// Initialize Firebase services (production only)
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Export the app instance
export { app };
